import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "modalType": null,
    "modalProps": {
      open: false
    }
}

const popUpData = createSlice({
    name:'popUpData',
    initialState,
    reducers : {
        showModalData: (_state,payload)=>{
            return {
                "id" : uuidv4(),
                "modalProps": {
                    ...payload.payload
                 },
                 "type": payload.type
               }
        },
        hideModalData:(_state,payload)=>{
            return initialState
        }
    }
});

export default popUpData.reducer
export const showModal = popUpData.actions.showModalData
export const hideModal = popUpData.actions.hideModalData

